"use client"

import { useEffect } from "react"

import { guardViewTransitions } from "@/lib/view-transition-guard"

/**
 * Installs the view-transition abort guard for the whole app.
 *
 * Mounted next to `ViewTransitions` so it is in place before the first
 * navigation can start a transition. Renders nothing.
 */
export function ViewTransitionGuard() {
  useEffect(() => guardViewTransitions(document), [])
  return null
}
